import React, {useState} from 'react';
import RoomImagesSlider from "../components/RoomImagesSlider";
import FormSelection from "../components/modals/FormSelection";
import {Button} from "react-bootstrap"; // Убедись, что путь правильный

const roomTypes = [
    {
        id: 'club-standart',
        category: 'НОМЕРА КЛУБНОГО ЭТАЖА',
        title: 'СТАНДАРТ',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на клубном этаже с особыми условиями.',
        features: ['Однокомнатный', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/StandardClub/photo1.jpg',
            '/Assets/Rooms/StandardClub/photo2.png',
            '/Assets/Rooms/StandardClub/photo3.png',
            '/Assets/Rooms/StandardClub/photo4.png',
            '/Assets/Rooms/StandardClub/photo5.png',
        ],
        price: 'от 13250 руб/сутки',
        link: '/rooms/club-standart' // Ссылка на детальную страницу (если есть)
    },
    {
        id: 'club-deluxe',
        category: 'НОМЕРА КЛУБНОГО ЭТАЖА',
        title: 'ДЕЛЮКС',
        description: 'Просторный номер повышенной комфортности на клубном этаже. Идеально подходит для длительного пребывания.',
        features: ['Однокомнатный', 'Увеличенная площадь', 'Двуспальная кровать King-size', 'Современный санузел', 'Зона отдыха', 'Телевизор', 'Холодильник', 'Кондиционер', 'Набор мини-парфюмерии'],
        images: [
            '/Assets/Rooms/DeluxeClub/photo1.png',
            '/Assets/Rooms/DeluxeClub/photo2.png',
            '/Assets/Rooms/DeluxeClub/photo3.png',
            '/Assets/Rooms/DeluxeClub/photo4.png',
            '/Assets/Rooms/DeluxeClub/photo5.png',
            '/Assets/Rooms/DeluxeClub/photo6.png',
        ],
        price: 'от 14500 руб/сутки',
        link: '/rooms/club-deluxe'
    },
    {
        id: 'club-lux',
        category: 'НОМЕРА КЛУБНОГО ЭТАЖА',
        title: 'ЛЮКС',
        description: 'Роскошный двухкомнатный номер на клубном этаже. Изысканный дизайн и максимум удобств для взыскательных гостей.',
        features: ['Двухкомнатный', 'Гостиная и спальня', 'Двуспальная кровать King-size', 'Два санузла', 'Рабочая зона', 'Мягкая мебель', 'Кофемашина', 'Набор элитной мини-парфюмерии'],
        images: [
            '/Assets/Rooms/LuxClub/photo1.png',
            '/Assets/Rooms/LuxClub/photo2.png',
            '/Assets/Rooms/LuxClub/photo3.png',
            '/Assets/Rooms/LuxClub/photo4.png',
            '/Assets/Rooms/LuxClub/photo5.png',
            '/Assets/Rooms/LuxClub/photo6.png',
            '/Assets/Rooms/LuxClub/photo7.png',
        ],
        price: 'от 17000 руб/сутки',
        link: '/rooms/club-lux'
    },
    {
        id: 'main-standart-single',
        category: 'НОМЕРА ОСНОВНОГО ЭТАЖА',
        title: 'СТАНДАРТ ОДНОМЕСТНЫЙ',
        description: 'Компактный номер для одного гостя на основном этаже. Все необходимое для комфортного проживания.',
        features: ['Однокомнатный', 'Односпальная кровать', 'Санузел', 'Телевизор', 'Холодильник'],
        images: [
            '/Assets/Rooms/Standard/photo1.png',
            '/Assets/Rooms/Standard/photo2.png',
            '/Assets/Rooms/Standard/photo3.png',
        ],
        price: 'от 8500 руб/сутки',
        link: '/rooms/main-standart-single'
    },
    {
        id: 'main-standart-double',
        category: 'НОМЕРА ОСНОВНОГО ЭТАЖА',
        title: 'СТАНДАРТ ДВУХМЕСТНЫЙ',
        description: 'Стандартный однокомнатный номер для двух гостей на основном этаже.',
        features: ['Однокомнатный', 'Две односпальные кровати или одна двуспальная', 'Санузел', 'Телевизор', 'Холодильник'],
        images: [
            '/Assets/Rooms/Standard2/photo1.jpeg',
            '/Assets/Rooms/Standard2/photo2.jpg',
            '/Assets/Rooms/Standard2/photo3.png',
            '/Assets/Rooms/Standard2/photo4.png',
            '/Assets/Rooms/Standard2/photo5.jpeg',
        ],
        price: 'от 8500 руб/сутки',
        link: '/rooms/main-standart-double'
    },
    {
        id: 'main-standart-improved-balcony',
        category: 'НОМЕРА ОСНОВНОГО ЭТАЖА',
        title: 'СТАНДАРТ УЛУЧШЕННЫЙ (С БАЛКОНОМ)',
        description: 'Улучшенный номер на основном этаже с выходом на балкон. Прекрасный вид и свежий воздух.',
        features: ['Однокомнатный', 'Балкон', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/StandardBalcony/photo1.png',
            '/Assets/Rooms/StandardBalcony/photo2.png',
            '/Assets/Rooms/StandardBalcony/photo3.png',
            '/Assets/Rooms/StandardBalcony/photo4.png',
            '/Assets/Rooms/StandardBalcony/photo5.png',
        ],
        price: 'от 9700 руб/сутки',
        link: '/rooms/main-standart-improved-balcony'
    },
    {
        id: 'main-standart-improved-no-balcony',
        category: 'НОМЕРА ОСНОВНОГО ЭТАЖА',
        title: 'СТАНДАРТ УЛУЧШЕННЫЙ (БЕЗ БАЛКОНА)',
        description: 'Улучшенный номер на основном этаже без балкона. Увеличенная площадь и дополнительный комфорт.',
        features: ['Однокомнатный', 'Увеличенная площадь', 'Двуспальная кровать или две односпальные', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/StandardNoBalcony/photo1.png',
            '/Assets/Rooms/StandardNoBalcony/photo2.png',
            '/Assets/Rooms/StandardNoBalcony/photo3.png',
            '/Assets/Rooms/StandardNoBalcony/photo4.png',
            '/Assets/Rooms/StandardNoBalcony/photo5.png',
        ],
        price: 'от 9300 руб/сутки',
        link: '/rooms/main-standart-improved-no-balcony'
    },
    {
        id: 'main-family',
        category: 'НОМЕРА ОСНОВНОГО ЭТАЖА',
        title: 'СЕМЕЙНЫЙ',
        description: 'Просторный номер, идеально подходящий для проживания с семьей. Дополнительные спальные места для детей.',
        features: ['Двухкомнатный или увеличенная площадь', 'Двуспальная кровать', 'Возможность установки дополнительных мест', 'Санузел', 'Телевизор', 'Холодильник', 'Кондиционер'],
        images: [
            '/Assets/Rooms/Family/photo1.png',
            '/Assets/Rooms/Family/photo2.png',
            '/Assets/Rooms/Family/photo3.png',
            '/Assets/Rooms/Family/photo4.png',
        ],
        price: 'от 10450 руб/сутки',
        link: '/rooms/main-family'
    },
    {
        id: 'main-lux',
        category: 'НОМЕРА ОСНОВНОГО ЭТАЖА',
        title: 'ЛЮКС',
        description: 'Просторный и элегантный двухкомнатный номер на основном этаже. Комфорт и уют для требовательных гостей.',
        features: ['Двухкомнатный', 'Гостиная и спальня', 'Двуспальная кровать King-size', 'Два санузла', 'Рабочая зона', 'Мягкая мебель', 'Кофемашина'],
        images: [
            '/Assets/Rooms/Lux/photo1.png',
            '/Assets/Rooms/Lux/photo2.png',
            '/Assets/Rooms/Lux/photo3.png',
            '/Assets/Rooms/Lux/photo4.png',
        ],
        price: 'от 11050 руб/сутки',
        link: '/rooms/main-lux'
    },
];

// Группируем номера по категориям (Клубный этаж, Основной этаж)
const groupedRoomTypes = Object.entries(roomTypes.reduce((acc, room) => {
    if (!acc[room.category]) {
        acc[room.category] = [];
    }
    acc[room.category].push(room);
    return acc;
}, {}));


const RoomsPage = () => {

    const [formSelectionVisible, setFormSelectionVisible] = useState(false);

    return (
        <div className="rooms-page-container"> {/* Уникальный класс для контейнера страницы номеров */}
            <header className="page-header"> {/* Переиспользуем класс заголовка страницы */}
                <h1>Номера Санатория "Родник"</h1> {/* Заголовок страницы */}
            </header>

            <div className="sections-wrapper"> {/* Переиспользуем обертку для секций/категорий */}

                {/* Проходимся по категориям номеров */}
                {groupedRoomTypes.map(([category, rooms], categoryIndex) => (
                    // Каждая категория - это отдельная секция
                    <section className="room-category-section" key={categoryIndex}> {/* Класс для секции категории номеров */}
                        <h2 className="room-category-title">{category}</h2> {/* Заголовок категории */}

                        <div className="room-list-alternating"> {/* НОВЫЙ КЛАСС: Контейнер для списка номеров с чередованием */}
                            {/* Проходимся по номерам внутри категории */}
                            {rooms.map((room, roomIndex) => (
                                <div className={`room-card-alternating ${roomIndex % 2 !== 0 ? 'reverse' : ''}`} key={room.id}> {/* НОВЫЙ КЛАСС: Карточка с чередованием. Добавляем класс 'reverse' для каждого второго элемента */}

                                    <div className="room-image-slider-container-alt"> {/* НОВЫЙ КЛАСС: Контейнер для слайдера в альтернативном макете */}
                                        {room.images && room.images.length > 0 ? (
                                            <RoomImagesSlider images={room.images} /> // <-- Передаем массив картинок для текущего номера
                                        ) : (
                                            // Placeholder, если нет картинок
                                            <div className="no-images-placeholder-alt">Нет фото</div>
                                            )}
                                    </div>

                                    <div
                                        className="room-info-block-alt"> {/* НОВЫЙ КЛАСС: Блок информации о номере в альтернативном макете */}
                                        <h3 className="room-title-alt">{room.title}</h3> {/* Название номера */}
                                        <p className="room-description-alt">{room.description}</p> {/* Описание */}

                                        {room.features && room.features.length > 0 && (
                                            <div
                                                className="room-features-block-alt"> {/* НОВЫЙ КЛАСС: Обертка для списка особенностей */}
                                                <h4 className="features-title-alt">Особенности
                                                    номера:</h4> {/* Заголовок для особенностей */}
                                                <ul className="room-features-list-alt"> {/* НОВЫЙ КЛАСС: Список особенностей */}
                                                    {room.features.map((feature, featureIndex) => (
                                                        <li key={featureIndex}>{feature}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                        {room.price &&
                                            <div className="room-price-alt">
                                                <Button
                                                    variant="success"
                                                    className="room-details-button"
                                                    onClick={() => setFormSelectionVisible(true)} // <-- ВОТ ОБРАБОТЧИК ОТКРЫТИЯ МОДАЛКИ
                                                    size="sm"
                                                >
                                                    ПОДРОБНЕЕ
                                                </Button>
                                                {room.price}
                                            </div>
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                ))}
            </div>
            {/* Конец .sections-wrapper */}
            <FormSelection show={formSelectionVisible} onHide={() => setFormSelectionVisible(false)}/>
        </div> // Конец .rooms-page-container
    );
};

export default RoomsPage;